<ng-container *ngIf="showEmailModal">
    <div class="modal fade emailModal" [class.email-disabled]="showWarningPopup" data-backdrop="false" role="dialog" aria-labelledby="myLargeModalLabel" id="modalPopUp">
        <div id="email-modal-dialog" class="modal-dialog email-modal-height " [ngClass]="{'before-close': beginCloseWidget}">
            <div class="modal-content" *ngIf="showEmailModal">
                <!--class emailDraft is to close body content when click add record in jobs screen-->
                <div class="modal-header select-cursor emailDraft" (click)="emailDraft_($event)">
                    <h4 class="modal-title" id="myModalLabel">
                        <div class="dropdown" id="drop-down-emails">
                            <span translate>Send.email.from:</span>
                            <span class="select-cursor" id="fromEmailDropdown" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false" (click)="openFromEmailDropdown($event)">
                                {{currentUserEmail}} &nbsp;<i class="fa fa-angle-down" aria-hidden="true"
                                    id="emailChoose"></i>
                            </span>
                            <!--                            <div class="dropdown-menu dropdown-fromEmail" aria-labelledby="fromEmailDropdown"-->
                            <!--                                id="emailList">-->
                            <!--                                <span class="dropdown-menu-arrow-record email-right"></span>-->
                            <!--                                <ng-container *ngFor="let address of fromAddress">-->
                            <!--                                    <a [ngClass]="{'s-email' : address.description == currentUserEmail}"-->
                            <!--                                        class="dropdown-item cursor-pointer"-->
                            <!--                                        (click)="getSelectedFromAddress(address, $event)">{{address?.description}}-->
                            <!--                                    </a>-->
                            <!--                                </ng-container>-->
                            <!--                            </div>-->
                        </div>
                        <span class="email-pointer float-right mail-close" id="email-close">
                            <i class="fa fa-times cursor-pointer" aria-hidden="true"></i>
                        </span>
                        <span class="email-pointer float-right mail-minimize">
                            <span *ngIf="!emailDraft">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="emailDraft">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                        </span>
                    </h4>
                </div>

                <div class="modal-body" [hidden]="emailDraft">
                    <ng-container>
                        <!--Template list-->
                        <div class="template-wrapper email-template-wrapper"
                            [style.background-color]="templateList?.length==0 ? '#ffffff' : '#F2F2F2'">
                            <div class="email-search-bar-container template-search-icon" *ngIf="showTemplateList">
                                <app-use-template [screen]="'email_template'" [screenLabel]="screenLabel"
                                    [showAddNewTemplate]="showAddNewTemplate"
                                                  (selectedItem)="setTemplateDetails($event)"
                                                  (cancelEvent)="cancelTemplate()"
                                                  [openDropDown]=showTemplateList>

                                </app-use-template>
                            </div>
                        </div>
                        <!--Template list-->

                        <!-- From email address -->

                        <div class="from-address from-address-wrapper">
                            <div class="search-wrapper">
                                <div class="search-container">
                                    <i class="fa fa-search search-icon"></i>
                                    <input class="search-address" placeholder="Search mail or name"
                                           [(ngModel)]="fromEmailSearchValue" (keyup)="searchFromEmail()">
                                    <span class="from-email-clear-input" onclick="event.stopPropagation();"
                                          *ngIf="fromEmailSearchValue" (click)="clearFromEmailSearch()"><i
                                        class="fa fa-times-circle" aria-hidden="true"></i></span>
                                </div>
                                <a class="cancel-template" (click)="closeFromEmailModal()">Cancel</a>
                            </div>
                            <div class="from-email-list-wrapper slim-scroll">
                                <ng-container *ngFor="let record of filteredFromAddress">
                                    <div class="from-email-list" [class.selected]="record?.selected"
                                         (click)="getSelectedFromAddress(record, $event)">
                                        <div class="from-name"> {{ record.name }}</div>
                                        <div class="from-address-email"> {{ record.description }}</div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="!filteredFromAddress.length && fromEmailSearchValue">
                                    <div class="no-from-address-found">
                                        <i class="fa fa-question-circle"></i>
                                        <div class="no-result-text"> There are no search results</div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <div class="attachment-container">
                            <ng-container *ngIf="attachments?.length==0">
                                <div class="no-results with-large-top-margin">
                                    <div class="warning-icon-wrap with-info-icon">
                                        <span class="ss-info icon fix-left"></span>
                                    </div>
                                </div>
                                <div class="warning-message ng-binding text-align-center">
                                    <!-- <span translate *ngIf="!isCommonRoute">No.available.files</span> -->
                                    <span translate>No.files.are.available</span>
                                </div>
                                <div class="template-footer">
                                    <span class="cancel-button pointer-cursor float-right" (click)="cancelAttachments()"
                                        translate>Cancel
                                    </span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="attachments?.length != 0">
                                <div class="template-header header-background" translate>
                                    Available.files <span class="attachment-size">- {{totalSizeofAttachment}} MB / 16
                                        MB</span>
                                </div>
                                <div class="attach-file-content attachemnt-file-bg-height">
                                    <div class="template-search margin-right-align">
                                        <div class="search">
                                            <span class="fa fa-search search-icon"></span>
                                            <input placeholder="Search" class="search-width"
                                                [(ngModel)]="filterParams.search" (keyup)="searchFiles()">
                                        </div>
                                    </div>
                                    <ul class="attachment-lists" *ngIf="!attachNotFound">
                                        <li class="template-data" *ngFor="let attachment of attachments"
                                            (click)="onNativeChange($event)">
                                            <ng-container>
                                                <input type="checkbox" [checked]="attachment?.selected"
                                                    [id]="attachment?.name" [name]="attachment?.name"
                                                    [value]="attachment?.id" class="checkbox-attachment"
                                                    [disabled]="attachment.hasOwnProperty('isRemovable')">
                                                <span
                                                    class="template-name attach-file-overflow">{{attachment?.name}}</span>
                                                {{showAttachmentName('',attachment?.size)}}
                                                <span class="large-file-ui"
                                                    *ngIf="isLargeFileSize && !attachment?.attached"
                                                    translate>file.size.large
                                                </span>
                                            </ng-container>
                                        </li>
                                    </ul>
                                    <ng-container *ngIf="attachNotFound">
                                        <div class="attachment-lists warning-container-height">
                                            <div class="warning-icon-wrap with-info-icon">
                                                <span class="ss-info icon fix-left"></span>
                                            </div>
                                            <div class="warning-message ng-binding text-align-center" translate>
                                                No.Record.Found.Search
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="attachment-footer">
                                    <div class="footer-right float-right">
                                        <span class="template-color cursor-pointer text-padding"
                                            (click)="cancelAttachments()" translate>Cancel
                                        </span>
                                        <button class="btn btn-primary mr-btn btn-align-margin"
                                            (click)="showAttachedFiles()"
                                            [disabled]="!showAttachfileButton || totalSizeofAttachment > 16"
                                            translate>Attach.file.and.return.to.email
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="ai-container">
                            <app-ai-prompt (cancelEmit)="closePanel()" #aiInstance (insertMailEmit)="insertMail($event)" [tags]="tags"
                             [screenType]="screenType" [emailHandleTagData]="emailHandleTagData" [footerMessage]="footerMessage" [mailContent]="templateData['message']"></app-ai-prompt>
                        </div>
                        <div class="email-error-message">
                            <ng-container *ngIf="showEmailError">
                                <div class="no-results-wrap with-large-top-margin">
                                    <div class="warning-icon-wrap with-info-icon with-warning-icon">
                                        <span class="ss-alert icon fix-left"></span>
                                    </div>
                                </div>
                                <div class="warning-message ng-binding text-align-center" translate>
                                    {{emailErrorMessage}}
                                </div>
                                <div class="template-footer">
                                    <span class="cancel-button pointer-cursor float-right" (click)="returnEmail()"
                                        translate>Return.to.email
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                        <ng-container>
                            <div class="emailbackdrop">
                                <form *ngIf="emailForm" [formGroup]="emailForm">
                                    <div class="job-complete" *ngIf="emailActivityShow">
                                        <label class="checkbox-button margin-btm0" for="emailComplete">
                                            <input class="checkbox-button__input" type="checkbox" id="emailComplete"
                                                [checked]="completed" (change)="completeActivity($event)" />
                                            <span class="checkbox-button__control complete-check"></span>
                                            <span class="checkbox-button__label" translate>
                                                <i class="fa fa-envelope margin-r5" aria-hidden="true"></i>
                                                <span translate>activity.email.today</span>
                                            </span>
                                        </label>
                                    </div>
                                    <div id="emailcontent" class="main">
                                        <!-- PORTAL LINK WARNING STRIP -->
                                        <div class="portal-strip" *ngIf="!portalStripIgnored && showPortalStrip">
                                            <span class="portal-strip-text">
                                                It looks like this email doesn’t have the portal link.
                                                The customer wont be able to accept the proposal online without it.
                                            </span>

                                            <div class="portal-strip-actions">
                                                <span class="portal-strip-ignore" (click)="ignorePortalStrip(true)">Ignore</span>
                                                <button *ngIf="aiModuleCheck" class="portal-strip-add" (click)="addPortalLink('aiden')">
                                                    <img src="images/aiden.svg"><span>Add portal link</span></button>
                                                <button *ngIf="!aiModuleCheck" class="portal-link-btn" (click)="addPortalLink('none')">
                                                    <span style="padding-left: 4px;">Add portal link</span></button>
                                            </div>
                                        </div>

                                        <div class="to-email-container">
                                            <select id="emailTo" class="full-width-select2 select-blk email-receipient"
                                                csSelect2 [select2Config]="select2Config" formControlName="toAddresses"
                                                [multiple]="true" (opened)="closeDropdown()"
                                                (selected)="getToAddress($event)" placeholder="To">
                                                <option *ngFor="let customer of customerContacts" [value]="customer.id">
                                                    {{customer?.description}}</option>
                                            </select>
                                            <a class="cc-text" (click)="showCcOption()"> <span *ngIf="!showCc">Add
                                                    cc</span></a>
                                        </div>
                                        <div class="cc-email-container" *ngIf="showCc">
                                            <select id="emailCc" class="full-width-select2 select-blk cc-mail" csSelect2
                                                [select2Config]="select2Config" formControlName="ccAddresses"
                                                [multiple]="true" (opened)="closeDropdown()"
                                                (selected)="getCcAddress($event)" placeholder="Cc">
                                                <option *ngFor="let customer of ccContacts" [value]="customer.id">
                                                    {{customer?.description}}</option>
                                            </select>
                                            <a class="cc-text" (click)="removeCcOption()">Remove cc</a>
                                        </div>
                                        <div class="tiny-mce-single-line-input-wrapper subject-tiny-mce">
                                            <input type="text" id="email-template-subject" formControlName="subject"
                                                class="form-blk">
                                        </div>
                                        <div class="textarea-container">
                                            <div class="editor-skeleton" *ngIf="aiLoad">
                                                <div class="sk-line l1"></div>
                                                <div class="sk-line l2"></div>
                                                <div class="sk-line l3"></div>
                                            </div>
                                            <textarea id="email-template-message" style="height: 400px;" rows="8" cols="70"
                                                class="controls textareatest  tiny-mce-single-line-input-wrapper"
                                                [ngClass]="{'modal-textarea':!emailActivityShow,'modalemail-textarea':emailActivityShow}"
                                                formControlName="content" (keyup)="onContentChange()" (keydown)="onContentChange()" (input)="onContentChange()">
                                            </textarea>
                                        </div>


                                        <ul class="attached_files_list attach-background"
                                            *ngIf="attachedFiles.length > 0 || pdfFiles.length > 0">
                                            <li *ngIf="attachedFiles.length > attached_files_view_limit"
                                                class="view-more-link">
                                                <i>And <strong>{{attachedFiles.length -
                                                        attached_files_view_limit}}</strong>
                                                    more</i>
                                                <span class="delete-link text-only" (click)="showAttachments()">
                                                    <a translate>View.all</a>
                                                </span>
                                            </li>
                                            <ng-container *ngFor="let attached_file of attachedFiles;let i = index">
                                                <li class="flex-display" *ngIf="i < attached_files_view_limit ">
                                                    <div class="attachment-title">{{attached_file.name}}</div>
                                                    <span class="delete-link cancel-btn-margin-top"
                                                        (click)="deleteAttachedFile(attached_file)"
                                                        *ngIf="!attached_file.hasOwnProperty('isRemovable')">
                                                        <span class="ss-delete"></span>
                                                    </span>
                                                </li>
                                            </ng-container>
                                            <li *ngFor="let attached_file of pdfFiles;let i = index">
                                                <ng-container>
                                                    <span class="attachment-title">
                                                        {{attached_file.fileName}}
                                                    </span>
                                                    <span class="file-size">MB</span>
                                                    <span class="delete-link"
                                                        (click)="deleteAttachedFile(attached_file)">
                                                        <span class="ss-delete"></span>
                                                    </span>
                                                </ng-container>
                                            </li>
                                        </ul>
                                    </div>
                                </form>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
                <div id="tag-autocomplete"
                    style="position:absolute; background:white; border:1px solid #ccc; display:none; z-index:999999;">
                </div>
                <!-- Footer -->
                <div class="modal-footer" [hidden]="emailDraft" [ngClass]="{'attachments-over': modalBack == true }">
                    <div>
                        <div *ngIf="!sendPdf" class="float-left icon-wrapper email-dropdown" id="dropdown1">
                            <ng-container>
                                <div class="float-left use-templates-mt-4 cursor-pointer" [ngClass]="{'icon-disabled': showAI == true}">
                                    <i class="fa-regular fa-folder-open" [class.active-icon]="folderStructureActive"
                                    (click)="showTemplateOptions()"></i>
                                </div>
                                <div class="cursor-pointer" (click)="showAttachments()" [ngClass]="{'icon-disabled': showAI == true}">
                                    <i class="fa fa-paperclip paperclip-icon" aria-hidden="true"
                                    [class.active-icon]="fileActive"></i>
                                </div>

                                <div class="cursor-pointer sparkle-div" (click)="showPrompt()" *ngIf="!showAI  && templateData['message'] == '' && aiModuleCheck">
                                    <img  class="icon"  src="images/Sparkle-AI.svg">
                                </div>

                                <div *ngIf="aiModuleCheck && (showAI || templateData['message'] != '')" (click)="getModal($event)" class="cursor-pointer sparkle-div dropdown-toggle" id="dropdowncontainer" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false" style="display: inline-flex;vertical-align: middle;" [ngStyle]="{'margin-top' :  showAI || templateData['message'] != '' ? '12px' : '0px'}">
                                       <img *ngIf="!showDiv" class="active-sparkle" src="images/Vector.svg">
                                       <img *ngIf="showDiv" class="active-sparkle mw" src="images/Sparkle-drop.svg">
                                </div>
                                <div class="dropdown-menu dropdown-menu1" [ngStyle]="{'top' : emailActivityShow ? '240px' : '208px'}" aria-labelledby="dropdowncontainer" (click)="$event.stopPropagation()" >
                                    <!-- <div class="search_div">
                                        <div class="search-box-ai">
                                            <span class="search-ai"></span>
                                            <input class="search-input" [(ngModel)]="aiSearch" placeholder="Search text AI" (keyup)="searchText()">
                                        </div>
                                    </div> -->
                                    <ul class="notes_list">
                                        <span *ngIf="filteredOptions.length" class="flex-display font-bold">Rewrite</span>
                                        <li *ngFor=" let option of filteredOptions; let i = index; ">
                                            <span class="custom_checkbox">
                                            <input type="checkbox" (click)="isSelectText($event,'rewrite',i,option.label)" [checked]="option.checked" value="{{option.value}}"
                                                name="option" id="{{'option'+ i}}" />
                                            <label class="cursor-pointer" for="{{'option'+ i}}">
                                                <span>{{option.label}}</span>
                                            </label>
                                            </span>
                                        </li>
                                        <span *ngIf="filteredTones.length" class="flex-display font-bold">Adjust tone</span>
                                        <li *ngFor=" let tone of filteredTones; let i = index; ">
                                            <span class="custom_checkbox">
                                            <input type="checkbox" (click)="isSelectText($event,'tone',i,tone.label)" [checked]="tone.checked" value="{{tone.value}}"
                                                name="tone" id="{{'tone'+ i}}" />
                                            <label class="cursor-pointer m-0" for="{{'tone'+ i}}">
                                                <span class="text_item">{{tone.label}}</span>
                                            </label>
                                            </span>
                                        </li>
                                    </ul>
                                    <div class="card-footer float-right">
                                        <button class="btn btn-primary" [disabled]="selectedNotes.length == 0" (click)="applyNotes()">Apply</button>
                                    </div>
                                  </div>
                            </ng-container>

                        </div>
                        <div *ngIf="!sendPdf && false" class="attachment-button cursor-pointer"
                            (click)="showAttachments()">
                            <div tooltip="Attachments"><i class="fa fa-paperclip paperclip-icon" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="float-right">
                            <span *ngIf="!sendPdf && !isFromJs && !showAttachment && emailModalData.screenType != 'vehicle' && this.emailModalData['pdfData'] == undefined" class="float-left">
                                <div class="schedule-check" *access="['ScheduleActivity.writeaccess']">
                                    <label class="checkbox-button checkbox-text-center" for="completeScheduleActivity">
                                        <input class="checkbox-button__input" type="checkbox"
                                            id="completeScheduleActivity" [checked]="scheduled"
                                            (change)="isScheduledActivity($event)" />
                                        <span class="checkbox-button__control"></span>
                                        <span class="checkbox-button__label" translate>Schedule.new.activity</span>
                                    </label>
                                </div>
                            </span>
                            <span *ngIf="this.emailModalData['pdfData'] && this.emailModalData['pdfData']['sendToCustomer'] == true && selectedTemplateId" class="float-left">
                                <div class="schedule-check">
                                    <label class="checkbox-button checkbox-text-center" for="updateTemplate">
                                        <input class="checkbox-button__input" type="checkbox"
                                            id="updateTemplate" [checked]="updateTemplate"
                                            (change)="isUpdateTemplate($event)" />
                                        <span class="checkbox-button__control"></span>
                                        <span class="checkbox-button__label" translate>Update template on send</span>
                                    </label>
                                </div>
                            </span>
                            <button class="btn disgard-button" (click)="closeModalConfirmation()" translate>
                                Discard
                            </button>
                            <button *ngIf="emailForm" class="btn btn-primary"
                                    [disabled]="!emailForm.valid || sendButtonDisabled || !toAddresses || (!portalStripIgnored && showPortalStrip)"
                                    (click)="sendEmail()" translate>
                                Send
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>


